import { BackupTranslationInterface } from '../models/backup-translation.model';
import { CustomFieldInterface } from '../models/custom-field.model';
import { LicenseDataInterface } from '../models/license-data.model';
import { PasswordSettingsInterface } from '../models/password-settings.model';
import { SiteEmailConfigInterface } from '../models/site-email-config.model';
import { SiteSettingInterface } from '../models/site-setting.model';
import { SiteSupportedLanguageInterface } from '../models/site-supported-language.model';
import { UserSessionSettingsInterface } from '../models/usersession-settings.model';
import { MessageBannerInterface, MessageInterface, MessageTextInterface } from '../models/message-banner.model';
import { ErrorSSOSingleInterface, ErrorsSSOInterface } from '../models/error-message';
import { SSOStatusInterface } from '../models/active.model';
import { SSOMetadataInterface } from '../models/sso-metadata.model';

import { SiteSettingActionType } from './actions/site-setings-action-type.enum';
import { SiteSettingActions } from './actions/site-settings-action.type';
import { SiteSettingsState, SiteSettingsStateInterface } from './models/site-settings-state.model';

const initialState: SiteSettingsState = new SiteSettingsState({
  settingsCollection: undefined,
  customFieldsCollection: undefined,
  siteEmailConfig: undefined,
  siteLicenseData: undefined,
  licenseUpdateResponse: undefined,
  siteSupportedLanguageCollection: undefined,
  backupTranslationResponse: undefined,
  passwordSettingsResponse: undefined,
  messageBanner: undefined,
});

export function siteSettingsReducer(state: SiteSettingsStateInterface = initialState,
                                    action: SiteSettingActions): SiteSettingsStateInterface {
  switch (action.type) {

    case SiteSettingActionType.LoadSiteSettings:
      return  {
        ...state,
        settingsCollection: [],
      };

    case SiteSettingActionType.LoadSiteSettingsCompleted:
      const loadedSettingsCollection: SiteSettingInterface[] = action.payload as SiteSettingInterface[];

      return {
        ...state,
        settingsCollection: loadedSettingsCollection,
      };

    case SiteSettingActionType.LoadCustomFieldsCompleted:
      const loadedFieldsData: CustomFieldInterface[] = action.payload as CustomFieldInterface[];

      return {
        ...state,
        customFieldsCollection: loadedFieldsData,
      };

    case SiteSettingActionType.LoadEmailConfigCompleted:
    case SiteSettingActionType.UpdateEmailConfigCompleted:
      const siteEmailConfigData: SiteEmailConfigInterface = action.payload as SiteEmailConfigInterface;

      return {
        ...state,
        siteEmailConfig: siteEmailConfigData,
      };

    case SiteSettingActionType.LoadSiteLicenseCompleted:
      const siteLicenseData: LicenseDataInterface = action.payload as LicenseDataInterface;

      return {
        ...state,
        siteLicenseData,
      };
    case SiteSettingActionType.LoadMessageCompleted:
      const messagesData: MessageBannerInterface = action.payload as MessageBannerInterface;
      return {
        ...state,
        messageBanner: messagesData,
      };
    case SiteSettingActionType.LoadTextMessageCompleted:
      const messageText: MessageTextInterface = action.payload as MessageTextInterface;
      return {
        ...state,
        messageTextBanner: messageText,
      };
    case SiteSettingActionType.LoadErrorSSOMessageCompleted:
      const errorSSOMessage: ErrorsSSOInterface[] = action.payload as ErrorsSSOInterface[];
      return {
        ...state,
        errorsSSO: errorSSOMessage,
      };
    case SiteSettingActionType.UpdateErrorSSOMessageCompleted:
      const errorSSOMessageUpdated: ErrorSSOSingleInterface = action.payload as ErrorSSOSingleInterface;
      return {
        ...state,
        errorsSingleSSO: errorSSOMessageUpdated,
      };
    case SiteSettingActionType.LoadUserPropsCompleted:
      const userProps: SSOStatusInterface = action.payload as SSOStatusInterface;
      return {
        ...state,
        userProps: userProps,
      }
    case SiteSettingActionType.LoadErrorSSOSingleMessageCompleted:
      const errorSSOSingleMessage: ErrorSSOSingleInterface = action.payload as ErrorSSOSingleInterface;
      return {
        ...state,
        errorsSingleSSO: errorSSOSingleMessage,
      };
    case SiteSettingActionType.UpdateBannerMessageCompleted:
      const messageUpdated: MessageInterface = action.payload as MessageInterface;

      return {
        ...state,
        singleMessageBanner: messageUpdated
      };

    case SiteSettingActionType.UpdateSiteLicenseCompleted:
      const resposneMessage: string = action.payload;

      return {
        ...state,
        licenseUpdateResponse: resposneMessage,
      };

    case SiteSettingActionType.LoadSiteSupportedLanguageCompleted:
      const loadedLanguageFieldsData: SiteSupportedLanguageInterface[] = action.payload as SiteSupportedLanguageInterface[];
      return {
        ...state,
        siteSupportedLanguageCollection: loadedLanguageFieldsData,
      };

    case SiteSettingActionType.LoadBackupTranslateCompleted:
      const loadedBackupFieldsData: BackupTranslationInterface = action.payload as BackupTranslationInterface;

      return {
        ...state,
        backupTranslationResponse: loadedBackupFieldsData,
      };

    case SiteSettingActionType.CheckSsoKeyCompleted:
      const checkSsoKeyCompletedData: any = action.payload as any;

      return {
        ...state,
        ssoKeyValid: checkSsoKeyCompletedData,
      };

      case SiteSettingActionType.LoadSSOMetadataCompleted:
      const loadSSOMetadataComplete: SSOMetadataInterface = action.payload as SSOMetadataInterface;

      return {
        ...state,
        ssoMetadata: loadSSOMetadataComplete,
      };

    case SiteSettingActionType.LoadPasswordSettingsCompleted:
      const loadedPasswordSettingssData:PasswordSettingsInterface = action.payload as PasswordSettingsInterface;

      return {
        ...state,
        passwordSettingsResponse: loadedPasswordSettingssData,
      };
    case SiteSettingActionType.LoadUserSessionSettingsCompleted:
      const loadedUserSessionSettingssData:UserSessionSettingsInterface = action.payload as UserSessionSettingsInterface;

      return {
        ...state,
        userSessionSettingsResponse: loadedUserSessionSettingssData,
      };
  }
}
